import { getFromStorage, saveToStorage } from './used-vue/api/Storage';

const COOKIE_ACCEPTED_EVENTS = {
    functional: 'cookies:accepted:functional',
    analytical: 'cookies:accepted:analytical',
    marketing: 'cookies:accepted:marketing',
};

let acceptFunctional = false;
if (getFromStorage('cookies_functional') == 1) {
    acceptFunctional = true;
}
let acceptAnalytical = false;
if (getFromStorage('cookies_analytical') == 1) {
    acceptAnalytical = true;
}
let acceptMarketing = false;
if (getFromStorage('cookies_marketing') == 1) {
    acceptMarketing = true;
}
let cookiesAccepted = false;
if (getFromStorage('cookies_accepted') == 1) {
    cookiesAccepted = true;
}

const initGoogleMaps = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDoBjhfSsYd9pjdbAq6GeMgHcfk5KLD120&libraries=places&callback=googleMapsLoaded';
    document.head.appendChild(script);
};

const initHotjar = () => {
    if (typeof window.loadHotjar == 'undefined') {
        return;
    }
    if (window.loadHotjar === false) {
        return;
    }
    (function (h, o, t, j, a, r) {
        h.hj =
            h.hj ||
            function () {
                (h.hj.q = h.hj.q || []).push(arguments);
            };
        h._hjSettings = { hjid: 2901373, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
};

const emitAcceptedCookieEvent = (type) => {
    const eventName = COOKIE_ACCEPTED_EVENTS[type];
    if (!eventName) {
        return;
    }

    window.dispatchEvent(new CustomEvent(eventName, {
        detail: {
            type,
        },
    }));
};

const initFunctional = () => {
    if (!acceptFunctional) {
        saveToStorage('cookies_functional', 0);
        return;
    }
    acceptFunctional = true;
    saveToStorage('cookies_functional', 1);
    emitAcceptedCookieEvent('functional');
};

const initAnalytical = () => {
    if (!acceptAnalytical) {
        saveToStorage('cookies_analytical', 0);
        return;
    }
    acceptAnalytical = true;
    saveToStorage('cookies_analytical', 1);
    emitAcceptedCookieEvent('analytical');
};

const initMarketing = () => {
    if (!acceptMarketing) {
        saveToStorage('cookies_marketing', 0);
        return;
    }
    acceptMarketing = true;
    saveToStorage('cookies_marketing', 1);
    emitAcceptedCookieEvent('marketing');
    initHotjar();
};

const updateGoogleTagManager = () => {
    gtag('consent', 'update', {
        ad_user_data: acceptMarketing ? 'granted' : 'denied',
        ad_personalization: acceptMarketing ? 'granted' : 'denied',
        ad_storage: acceptMarketing ? 'granted' : 'denied',
        analytics_storage: acceptAnalytical ? 'granted' : 'denied',
    });
    dataLayer.push({ event: 'consent_values_updated' });
};

const initCookieDescriptionAcordions = () => {
    const headings = cookieCard.querySelectorAll('.cookie-card__summary-heading');
    headings.forEach((heading) => {
        heading.addEventListener('click', (event) => {
            const target = heading.getAttribute('aria-controls');
            if (!target) {
                console.error('Target not found for value: ' + heading.dataset.target);
                return;
            }
            // Get the element parent and then get the .cookie-card__summary-expand
            const expandIcon = heading.querySelector('.cookie-card__summary-expand');
            if (expandIcon) {
                expandIcon.classList.toggle('cookie-card__summary-expand--open');
            }
            const targetElement = cookieCard.querySelector('#' + target);
            if (!targetElement) {
                console.error('Target not found for value: ' + target);
                return;
            }
            targetElement.classList.toggle('cookie-card__summary-content--open');
        });
    });
};

const cookieCard = document.getElementById('cookieCardBg');
const initCookieCard = () => {
    if (!cookieCard) {
        console.error('Cookie card not found');
        return;
    }

    document.querySelector('html').classList.add('cookie-card-active');

    if (cookiesAccepted) {
        initFunctional();
        initAnalytical();
        initMarketing();
        updateGoogleTagManager();
        document.querySelector('html').classList.remove('cookie-card-active');
        cookieCard.remove();
        return;
    }

    cookieCard.classList.add('cookie-card--open');

    initCookieDescriptionAcordions();

    cookieCard.querySelector('.cookie-card__button--accept').addEventListener('click', (event) => {
        acceptFunctional = true;
        acceptAnalytical = true;
        acceptMarketing = true;

        initFunctional();
        initAnalytical();
        initMarketing();
        updateGoogleTagManager();

        saveToStorage('cookies_accepted', 1);
        document.querySelector('html').classList.remove('cookie-card-active');
        cookieCard.remove();
    });

    cookieCard.querySelector('.cookie-card__button--reject').addEventListener('click', (event) => {
        acceptFunctional = false;
        acceptAnalytical = false;
        acceptMarketing = false;

        initFunctional();
        initAnalytical();
        initMarketing();
        updateGoogleTagManager();

        saveToStorage('cookies_accepted', 1);
        document.querySelector('html').classList.remove('cookie-card-active');
        cookieCard.remove();
    });

    cookieCard.querySelector('.cookie-card__button--save').addEventListener('click', (event) => {
        initFunctional();
        initAnalytical();
        initMarketing();
        updateGoogleTagManager();

        saveToStorage('cookies_accepted', 1);
        document.querySelector('html').classList.remove('cookie-card-active');
        cookieCard.remove();
    });

    cookieCard.querySelectorAll('.cookie-card__button--settings').forEach((settingsButtonElement) =>
        settingsButtonElement.addEventListener('click', (event) => {
            cookieCard.querySelectorAll('.modal__inner').forEach((element) => (element.style.display = 'none'));
            cookieCard.querySelector('.modal__inner--manage').style.display = 'block';
        }),
    );

    cookieCard.querySelector('.cookie-card__button--default').addEventListener('click', (event) => {
        cookieCard.querySelectorAll('.modal__inner').forEach((element) => (element.style.display = 'none'));
        cookieCard.querySelector('.modal__inner--default').style.display = 'block';
    });

    cookieCard.querySelectorAll('.cookie-card__more-info').forEach((moreInfoElement) => {
        moreInfoElement.addEventListener('click', (event) => {
            const target = cookieCard.querySelector(moreInfoElement.dataset.target);
            if (!target) {
                console.error('Target not found for value: ' + moreInfoElement.dataset.target);
                return;
            }

            cookieCard.querySelectorAll('.modal__inner').forEach((element) => (element.style.display = 'none'));
            target.style.display = 'block';
        });
    });

    cookieCard.querySelectorAll('.redesign-checkbox__input').forEach((checkboxElement) => {
        checkboxElement.addEventListener('change', (event) => {
            if (checkboxElement.value == 'functional') {
                acceptFunctional = checkboxElement.checked;
                return;
            }
            if (checkboxElement.value == 'analytical') {
                acceptAnalytical = checkboxElement.checked;
                return;
            }
            if (checkboxElement.value == 'marketing') {
                acceptMarketing = checkboxElement.checked;
                return;
            }
            console.error('Checkbox not found for value: ' + checkboxElement.value);
        });
    });
};
initGoogleMaps();
initCookieCard();
